export default "__VITE_ASSET__CXDg0cMT__"